import useCollegeFeatures from 'common/use-college-features'
import features from 'common/college-features'
import usePermissions from 'common/use-permissions'
import permissions from 'common/system-permissions'
import useIsShadow from 'common/use-is-shadow'

export const useCanViewReadOnly = () => {
  const isApplicationIntegrationEnabled = useCollegeFeatures(features.APPLICATION_INTEGRATION)
  const hasApplicationManagerPermission = usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
  return isApplicationIntegrationEnabled && !hasApplicationManagerPermission
}

export const useIsApplicationIntegrationEnabled = () => {
  return useCollegeFeatures(features.APPLICATION_INTEGRATION)
}

export default () => {
  const isShadow = useIsShadow()
  const isApplicationIntegrationEnabled = useCollegeFeatures(features.APPLICATION_INTEGRATION)
  const hasApplicationManagerPermission = usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
  return (isApplicationIntegrationEnabled && hasApplicationManagerPermission) || isShadow
}
